import { ButtonHTMLAttributes, HTMLProps } from "react"

const SecondaryButton = ({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button {...props} className={`secondary-button ${className}`} type="button" />
}

export default SecondaryButton